// 阀门类型映射配置
export const valveTypes = {
  '阀门': 'gis_pipe_network_valve',
  '水表': 'gis_pipe_network_water_meter',
  '排水阀': 'gis_pipe_network_drainage_valve',
  '排气阀': 'gis_pipe_network_drainage_valve',
  '止回阀': 'gis_pipe_network_drainage_valve',
  '减压阀': 'gis_pipe_network_drainage_valve',
  '互联互通阀门': 'gis_pipe_network_drainage_valve',
  '水箱': 'gis_pipe_network_water_tank',
  '水池': 'gis_pipe_network_water_tank',
}

// 要素配置数据
export const featureConfigs = {
  // 管线要素配置
  gis_pipe_line: [
    {
      id: 'start_class_no',
      name: '起点分类编码',
      clickable: {
        type: 'pipelineClassNo',
        action: 'navigateToPipeLine'
      }
    },
    {
      id: 'end_class_no',
      name: '终点分类编码',
      clickable: {
        type: 'pipelineClassNo',
        action: 'navigateToPipeLine'
      }
    },
    {
      id: 'pipe_material',
      name: '管材'
    },
    {
      id: 'pipe_diameter',
      name: '管径',
      rule: {
        position: 'before',
        text: 'DN'
      }
    },
    {
      id: 'pipe_attribute',
      name: '管线属性'
    },
    {
      id: 'buried_depth',
      name: '起点埋深',
      rule: {
        position: 'after',
        text: 'm'
      }
    },
    // {
    //   id: 'start_buried_depth',
    //   name: '起点埋深',
    //   rule: {
    //     position: 'after',
    //     text: 'm'
    //   }
    // },
    {
      id: 'end_buried_depth',
      name: '终点埋深',
      rule: {
        position: 'after',
        text: 'm'
      }
    },
    {
      id: 'length',
      name: '长度',
      rule: {
        position: 'after',
        text: 'm'
      }
    },
    {
      id: 'completion_date',
      name: '竣工时间'
    }
  ],

  // 管点要素配置
  gis_pipe_network: [
    {
      id: 'feature_point',
      name: '物探点类型'
    },
    {
      id: 'geophysical_point_number',
      name: '物探点号'
    },
    {
      id: 'class_no',
      name: '分类编码',
      clickable: {
        type: 'pipeNetworkClassNo',
        action: 'navigateToPipeNetwork'
      }
    },
    {
      id: 'brand',
      name: '品牌'
    },
    {
      id: 'texture_material',
      name: '材质'
    },
    {
      id: 'caliber',
      name: '口径',
      rule: {
        position: 'before',
        text: 'DN'
      }
    },
    {
      id: 'point_x',
      name: '坐标X'
    },
    {
      id: 'point_y',
      name: '坐标Y'
    },
    {
      id: 'elevation',
      name: '地面高程'
    },
    {
      id: 'completion_date',
      name: '竣工时间'
    }
  ],

  search_pipe_network: [
    {
      id: 'feature_point',
      name: '物探点类型'
    },
    {
      id: 'geophysical_point_number',
      name: '物探点号'
    },
    {
      id: 'class_no',
      name: '分类编码',
      clickable: {
        type: 'pipeNetworkClassNo',
        action: 'navigateToPipeNetwork'
      }
    },
    {
      id: 'brand',
      name: '品牌'
    },
    {
      id: 'texture_material',
      name: '材质'
    },
    {
      id: 'caliber',
      name: '口径',
      rule: {
        position: 'before',
        text: 'DN'
      }
    },
    {
      id: 'point_x',
      name: '坐标X'
    },
    {
      id: 'point_y',
      name: '坐标Y'
    },
    {
      id: 'elevation',
      name: '地面高程'
    },
    {
      id: 'completion_date',
      name: '竣工时间'
    }
  ],


  // 附属物要素配置
  gis_pipe_network_appendage: [
    {
      id: 'appendage',
      name: '物探点类型'
    },
    {
      id: 'geophysical_point_number',
      name: '物探点号'
    },
    {
      id: 'class_no',
      name: '分类编码',
      clickable: {
        type: 'pipeNetworkClassNo',
        action: 'navigateToPipeNetwork'
      }
    },
    {
      id: 'brand',
      name: '品牌'
    },
    {
      id: 'caliber',
      name: '口径',
      rule: {
        position: 'before',
        text: 'DN'
      }
    },
    {
      id: 'point_x',
      name: '坐标X'
    },
    {
      id: 'point_y',
      name: '坐标Y'
    },
    {
      id: 'elevation',
      name: '地面高程'
    },
    {
      id: 'completion_date',
      name: '竣工时间'
    }
  ],

  // 构筑物要素配置
  gis_pipe_network_structure: [
    {
      id: 'structure',
      name: '构筑物类型'
    },
    {
      id: 'geophysical_point_number',
      name: '物探点号'
    },
    {
      id: 'class_no',
      name: '分类编码',
      clickable: {
        type: 'pipeNetworkClassNo',
        action: 'navigateToPipeNetwork'
      }
    },
    {
      id: 'brand',
      name: '品牌'
    },
    {
      id: 'point_x',
      name: '坐标X'
    },
    {
      id: 'point_y',
      name: '坐标Y'
    },
    {
      id: 'elevation',
      name: '地面高程'
    },
    {
      id: 'completion_date',
      name: '竣工时间'
    }
  ],

  // 阀门要素配置
  gis_pipe_network_valve: [
    {
      id: 'appendage',
      name: '物探点类型'
    },
    {
      id: 'geophysical_point_number',
      name: '物探点号'
    },
    {
      id: 'class_no',
      name: '分类编码',
      clickable: {
        type: 'pipeNetworkClassNo',
        action: 'navigateToPipeNetwork'
      }
    },
    {
      id: 'valve_type',
      name: '阀门类型'
    },
    {
      id: 'caliber',
      name: '口径',
      rule: {
        position: 'before',
        text: 'DN'
      }
    },
    {
      id: 'brand',
      name: '品牌'
    },
    {
      id: 'status',
      name: '状态'
    },
    {
      id: 'point_x',
      name: '坐标X'
    },
    {
      id: 'point_y',
      name: '坐标Y'
    },
    {
      id: 'elevation',
      name: '地面高程'
    },
    {
      id: 'completion_date',
      name: '竣工时间'
    },
    {
      id: 'valve_level',
      name: '阀门级别',
      hyperlink: {
        url: `pipe-network/gis-pipe-network/index?classNo=`,
        value: ['class_no'],
        way: 'open'
      }
    }
  ],

  // 排水阀要素配置
  gis_pipe_network_drainage_valve: [
    {
      id: 'appendage',
      name: '物探点类型'
    },
    {
      id: 'geophysical_point_number',
      name: '物探点号'
    },
    {
      id: 'class_no',
      name: '分类编码',
      clickable: {
        type: 'pipeNetworkClassNo',
        action: 'navigateToPipeNetwork'
      }
    },
    {
      id: 'valve_type',
      name: '阀门类型'
    },
    {
      id: 'caliber',
      name: '口径',
      rule: {
        position: 'before',
        text: 'DN'
      }
    },
    {
      id: 'brand',
      name: '品牌'
    },
    {
      id: 'status',
      name: '状态'
    },
    {
      id: 'point_x',
      name: '坐标X'
    },
    {
      id: 'point_y',
      name: '坐标Y'
    },
    {
      id: 'elevation',
      name: '地面高程'
    },
    {
      id: 'completion_date',
      name: '竣工时间'
    }
  ],

  // 水表要素配置
  gis_pipe_network_water_meter: [
    {
      id: 'appendage',
      name: '物探点类型'
    },
    {
      id: 'geophysical_point_number',
      name: '物探点号'
    },
    {
      id: 'class_no',
      name: '分类编码',
      clickable: {
        type: 'pipeNetworkClassNo',
        action: 'navigateToPipeNetwork'
      }
    },
    {
      id: 'point_x',
      name: '坐标X'
    },
    {
      id: 'point_y',
      name: '坐标Y'
    },
    {
      id: 'elevation',
      name: '地面高程'
    },
    {
      id: 'water_count',
      name: '水表数量',
      clickable: {
        type: 'class_no',
        value: ''
      },
    },
    {
      id: 'completion_date',
      name: '竣工时间'
    }
  ],

  // 水箱要素配置
  gis_pipe_network_water_tank: [
    {
      id: 'appendage',
      name: '物探点类型'
    },
    {
      id: 'geophysical_point_number',
      name: '物探点号'
    },
    {
      id: 'class_no',
      name: '分类编码',
      clickable: {
        type: 'pipeNetworkClassNo',
        action: 'navigateToPipeNetwork'
      }
    },
    {
      id: 'texture_material',
      name: '材质'
    },
    {
      id: 'point_x',
      name: '坐标X'
    },
    {
      id: 'point_y',
      name: '坐标Y'
    },
    {
      id: 'elevation',
      name: '地面高程'
    },
    {
      id: 'completion_date',
      name: '竣工时间'
    }
  ],

  // 片区范围示意图要素配置
  zone_metering: [
    {
      id: 'zoneName',
      name: '片区名称',
      hyperlink: {
        url: `partition/workbench?type=flow_rate&zoneId=`,
        value: ['zoneId'],
        way: 'open'
      }
    },
    {
      id: 'dn75Above',
      name: 'DN75以上管网长度',
      rule: {
        position: 'after',
        text: 'm'
      }
    },
    {
      id: 'userCount',
      name: '用户数',
      rule: {
        position: 'after',
        text: '户'
      },
      clickable: {
        type: 'zoneId',
        value: ''
      },
    },
    {
      id: 'nightFlow',
      name: '夜间流量',
      rule: {
        position: 'after',
        text: 'm³'
      },
      hyperlink: {
        url: `partition/workbench?type=night_flow&zoneId=`,
        value: ['zoneId'],
        way: 'open'
      }
    },
    {
      id: 'waterSupplycapacity',
      name: '昨日供水量',
      rule: {
        position: 'after',
        text: 'm³'
      },
      hyperlink: {
        url: `partition/workbench?type=net_flow&zoneId=`,
        value: ['zoneId'],
        way: 'open'
      }
    },
    {
      id: 'iflowRate',
      name: '瞬时流量',
      rule: {
        position: 'after',
        text: 'm³/h'
      },
      hyperlink: {
        url: `partition/workbench?type=flow_rate&zoneId=`,
        value: ['zoneId'],
        way: 'open'
      }
    },
    {
      id: 'waterForSale',
      name: '昨日售水量',
      rule: {
        position: 'after',
        text: 'm³'
      }
    },
    {
      id: 'productionAndSalesMargin',
      name: '昨日产销差率',
    },
    {
      id: 'subpartitioning',
      name: '子分区',
      components: {
        value: 'zoneId',
        show: 'childZoneBoxShow'
      }
    },
    {
      id: 'cumulativeAlarm',
      name: '累计报警',
      type: 'null'
    },
    {
      id: 'alarm',
      name: '报警',
      type: 'round',
      hyperlink: {
        url: `zone-alarm-management/zone-alarm-list?alarmLevel=报警&zoneId=`,
        value: ['zoneId'],
        way: 'open'
      }
    },
    {
      id: 'earlyWarning',
      name: '预警',
      type: 'round',
      hyperlink: {
        url: `zone-alarm-management/zone-alarm-list?alarmLevel=预警&zoneId=`,
        value: ['zoneId'],
        way: 'open'
      }
    },
    {
      id: 'interrupt',
      name: '数据中断',
      type: 'round',
      hyperlink: {
        url: `zone-alarm-management/zone-interrupt-list?zoneId=`,
        value: ['zoneId'],
        way: 'open'
      }
    },


  ],
  // 分界阀门要素配置
  zone_associated_point: [
    {
      id: 'appendage',
      name: '物探点类型'
    },
    {
      id: 'class_no',
      name: '分类编码'
    },
    {
      id: 'caliber',
      name: '口径'
    },
    {
      id: 'brand',
      name: '品牌'
    },
    {
      id: 'address',
      name: '安装地址'
    },
    {
      id: 'ground_elevation',
      name: '地面高程'
    },
    {
      id: 'remark',
      name: '备注'
    }
  ],
  // gis系统计量仪表要素配置

  remote_water_meter_gis: [
    {
      id: 'address',
      name: '地址'
    },
    {
      id: 'appearance_no',
      name: '仪表编号',
      hyperlink: {
        url: `pipe-network/gis-pipe-network/index?classNo=`,
        value: ['class_no'],
        way: 'open'
      }
    },
    {
      id: 'appearance_name',
      name: '仪表名称'
    },
    {
      id: 'diameter',
      name: '口径'
    },
    {
      id: 'class_no',
      name: '分类编码'
    },
    {
      id: 'flow_into',
      name: '片区'
    },
    {
      id: 'brand',
      name: '品牌'
    },
    {
      id: 'ground_elevation',
      name: '地面高程'
    }
  ],
  // 分区计量仪表要素配置
  remote_water_meter: [
    {
      id: 'address',
      name: '地址'
    },
    {
      id: 'appearance_no',
      name: '仪表编号',
      hyperlink: {
        id: 'appearance_no',
        url: `/partition/workbench`,
        value: ['zoneId'],
        way: 'open'
      }
    },
    {
      id: 'appearance_name',
      name: '仪表名称'
    },
    {
      id: 'diameter',
      name: '口径'
    },
    {
      id: 'class_no',
      name: '分类编码'
    },
    {
      id: 'flow_into',
      name: '片区'
    },
    {
      id: 'brand',
      name: '品牌'
    },
    {
      id: 'ground_elevation',
      name: '地面高程'
    }
  ]

}


// 获取要素配置的辅助函数
export function getFeatureConfig (featureId) {
  // 直接通过属性访问，更简洁高效
  return featureConfigs[featureId] || null
}
